module.exports = __webpack_public_path__ + "img/xp_coupon_10000.6fc08523.png";